// extracted by mini-css-extract-plugin
export var notificationHost = "_lb-0";